// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"21b5aa76","269":"105a0135","428":"ba7d994a","838":"b4a91deb","894":"7fcba09c"}[chunkId] + ".chunk.js";
};